import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-client-information',
    templateUrl: './client-information.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClientInformationComponent {

}
